
define(
	'Jeske.BSGSTracker.BSGSModule'
,   [
		'Jeske.BSGSTracker.BSGSModule.View'
	]
,   function (
		BSGSModuleView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var layout = container.getComponent('Layout');
			if (layout) {
				layout.addChildView('Header', function() {
					return new BSGSModuleView({ container: container });
				});
			}
		}
	};
});
